import axios from "axios";

export const state = {
    loanarrears: [],
};

export const getters = {
    loanarrears: state => state.loanarrears,
};

export const mutations = {
    setLoanArrears(state, newValue) {
        state.loanarrears = newValue
    },
};

export const actions = {
    async fetchLoanArrears({ commit }) {
        await axios.get('/loanarrears').then(res => {
            commit('setLoanArrears', res.data.loanarrears)
        })
    },
    async filterLoanArrears({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterloanarrears";
        await axios.post(url, formData).then((response) => {
            commit('setLoanArrears', response.data.loanarrears)
        })
    },
};
